import React from "react";
import clsx from "clsx";
import { useResizeDetector } from "react-resize-detector";

import { HvLoading, HvLoadingProps } from "@hitachivantara/uikit-react-core";
import useStyles from "./styles";

interface LoadingContainerProps extends HvLoadingProps {
  hidden: boolean;
}

const LoadingContainer: React.FC<LoadingContainerProps> = ({
  children,
  hidden,
  ...others
}) => {
  const classes = useStyles();

  const { ref } = useResizeDetector();

  return (
    <>
      <div
        style={{
          top: ref.current?.offsetTop,
          left: ref.current?.offsetLeft,
          height: ref.current?.clientHeight,
          width: ref.current?.clientWidth,
        }}
        className={clsx(classes.overlay, { [classes.blur]: !hidden })}
      >
        <HvLoading
          classes={{ root: classes.loading }}
          hidden={hidden}
          {...others}
        />
      </div>
      <div style={{ display: "flow-root" }} ref={ref}>
        {children}
      </div>
    </>
  );
};

export default LoadingContainer;
